<template>
  <!-- -->
  <div class="form-tag section-title">
    {{ label }}
    <slot/>
  </div>
</template>

<script>

export default {
  props: {
    label: {default: ""},
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.form-tag{
  margin-bottom: 10px;
  margin-top: 20px;
  font-weight: 500;
  &:first-child{
    margin-top: 0;
  }
}
.section-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 3px solid var(--el-color-primary);
  justify-content: space-between;
  i {
    margin-right: 8px;
    font-size: 16px;
  }
}
</style>